module.exports = __webpack_public_path__ + "static/media/PATS_2-1920w.ae3ac749.png";